import React, { useEffect } from 'react';
import { Link, useAsyncError, useRouteError } from 'react-router-dom';
import { useTranslation, Trans } from 'react-i18next';

const addGlobalStyles = () => {
  const css = `
    #page.page-error .contentTd2 #content { height: 700px !important; }
  `
  const head = document.head || document.getElementsByTagName('head')[0]
  const style = document.createElement('style')

  head.appendChild(style)

  style.id = 'error-yoga-man-styles'

  style.appendChild(document.createTextNode(css))
}

const removeGlobalStyles = () => {
  document.getElementById('error-yoga-man-styles').remove()
}

const getErrorCode = (error: string) => {
  let code = 404;

  if (error === "You don't have access to view this page.") {
    code = 403;
  }

  return code;
};

const ErrorImage = ({ errorCode }: { errorCode: number }) => {
  const imageSrc = `/wb/images/${errorCode}.png`;
  const imageStyle: React.CSSProperties = {
    display: 'block',
    maxWidth: '100%',
    margin: '0 auto',
  };

  if (errorCode === 403) {
    imageStyle.width = '300px';
    imageStyle.margin = '0 auto 20px';
  }

  return <img src={imageSrc} alt="Yoga Man" style={imageStyle} />;
};

const ErrorBlock = ({ errorCode }: { errorCode: number }) => {
  const { t } = useTranslation();
  let title = t('Just breathe...');
  let message = (
    <>
      {t("Ommmm, that's unfortunate. We couldn't find the link you wanted.")}
      <br />
      {t('Try again or let us know where things are stuck.')}
      <br />
      {/* {t('You can start again from the')} <Link to="/">{t('homepage')}</Link>. */}
      <Trans
        i18nKey="errorPage.tryAgainFromHomepage"
        components={{ HomepageLink: <Link to='/' /> }}
      />
    </>
  );

  if (errorCode === 403) {
    title = t('Take a moment...');
    message = (
      <>
        {t("You don't have permission to access this page.")}
        <br />
        <Trans
          i18nKey="errorPage.tryAgainFromYogaHomepage"
          components={{ HomepageLink: <Link to='/' /> }}
        />
      </>
    );
  }

  return (
    <>
      <h2 style={{ textAlign: 'center' }}>{title}</h2>
      <p
        style={{
          paddingBottom: '20px',
          paddingTop: '14px',
          fontWeight: 400,
          textAlign: 'center',
          fontSize: '17px',
        }}
      >
        {message}
      </p>
    </>
  );
};

export function ErrorYogaMan() {
  const error = useRouteError();
  const asyncError = useAsyncError();
  let errorText = '';

  if (error instanceof Error) {
    errorText = error.message;
  } else if (error && typeof error === 'object') {
    errorText = error.toString();
  } else if (asyncError instanceof Error) {
    errorText = asyncError.message;
  } else if (asyncError && typeof asyncError === 'object') {
    errorText = asyncError.toString();
  } else {
    errorText = 'Unknown error';
  }

  const errorCode = getErrorCode(errorText);

  useEffect(() => {
    addGlobalStyles();

    document.title = `Oops, ${errorCode}`;

    // eslint-disable-next-line no-console
    console.error('Router error boundary error', errorText);

    return () => {
      removeGlobalStyles();
    };
  }, [errorCode, errorText]);

  return (
    <div id="article-container" style={{ paddingTop: '70px', maxWidth: '100%' }}>
      <section id="blog" className="white">
        <div className="container" style={{ maxWidth: '100%' }}>
          <div className="row">
            <div className="col-12" style={{ maxWidth: '50%', minWidth: '300px', margin: '0 auto' }}>
              <ErrorImage errorCode={errorCode} />
            </div>
          </div>
          <div className="row">
            <div className="col-12" style={{ margin: '0 auto' }}>
              <ErrorBlock errorCode={errorCode} />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
